<router-outlet></router-outlet>
<!-- <app-login-register></app-login-register> -->
<alert></alert>
<spinner></spinner>
